import { AssetLoader } from '@/shared/utils';

export default async ({ $deferredLoader, $services, $store }) => {
  const info = $services.resolve('info');

  await info.fetch();
  const trackingScript = info.trackingScript;

  if (!trackingScript) {
    return;
  }

  $deferredLoader.appReady.promise
    .then(() => new AssetLoader().load([
      { id: 'tracking', src: trackingScript },
    ]))
    .catch(() => {
      $store.commit('atdsTracking/SET_TRACKING_SCRIPTS_BLOCKED', true);
    });
};
